import React, { FC } from "react";

interface Props {
    heading: string;
}

export const HeadingWithBreakpoints: React.FC<Props> = ({heading}) => {
    return (
        <span className="main" dangerouslySetInnerHTML={{__html: heading.replace(/\|/g, "&shy;")}}/>
    );
};
